<ms-error *ngIf="!grid" [links]="false" [message]="sitecore.event.ErrNoEvents" [severity]="'info'"></ms-error>
<ms-promoted-betbuilder *ngIf="promotedMarkets && promotedMarkets.length > 0" [promotedMarkets]="promotedMarkets"> </ms-promoted-betbuilder>
<div
    class="betbuilder__league-groups"
    msScrolledToBottom
    scrollContext="document"
    *ngIf="grid | async as model"
    (scrollAtBottom)="onScrollAtBottom()">
    <div class="grid-wrapper">
        <div class="grid-outer-title">{{ sitecore.betBuilder.messages.BetBuilderEventsTitle }}</div>
        <div class="betbuilder-grid-info-message" *ngIf="betBuilderConfig.isBetBuilderInfoMessageEnabled">
            <span class="badge badge-primary new-badge">{{ sitecore.globalMessages.NewBadgeText }}</span>
            <div>{{ sitecore.betBuilder.messages.InfoMessage }}</div>
        </div>
        <ms-grid
            [model]="model"
            [linkConfig]="gridLinkConfig"
            [tracking]="trackingSource"
            [hideHeader]="true"
            [hideMarketHeader]="true"
            [optionGroupTemplate]="betBuilderButton"
            [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
            (eventClick)="eventClicked()"></ms-grid>

        <ng-template #betBuilderButton let-event="event" let-hasPreCreated="hasPreCreated">
            <ms-bet-builder-button
                [event]="event"
                [hasPreCreated]="hasPreCreated"
                [allowBetslipOpening]="false"
                [buttonSource]="buttonSource"
                [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"></ms-bet-builder-button>
        </ng-template>

        <div class="grid-footer" *ngIf="hasMoreFixtures" (click)="onScrollAtBottom()">
            <div [class.spinner-img]="loading">{{ sitecore.event.MoreEvents }}</div>
        </div>
    </div>
</div>
